<template>
  <loader v-if="isLoading" />

  <subscriptions-matrix-overview
    v-else
    :subscribables="subscribables"
    :student-subscribables="studentSubscribables"
    :is-advanced-rubric="isAdvancedRubric"
    @showFilter="processShowFilter"
  >
    <group-subscriptions-filter
      slot="filter"
      v-model="filters"
      :subscribable-grouping-id="subscribableGroupingId"
      :api-route="apiRoute"
      style="margin-bottom: 10px;"
      :show-filter="showFilter"
    />

    <template
      slot="modal-extra-info"
      slot-scope="props"
    >
      <tr>
        <th>{{ trans('core.name') }}</th>
        <td>{{ nameOfGroup(props.subscribable) }}</td>
      </tr>
      <tr>
        <th>{{ trans('core.term') }}</th>
        <td>{{ termOfSelectedGroup(props.subscribable) }}</td>
      </tr>
    </template>
  </subscriptions-matrix-overview>
</template>

<script>
import GroupSubscriptionsFilter from '@/employees/components/Subscribable/GroupSubscriptionsFilter'
import Loader from '@/employees/components/Loader'
import SubscriptionsMatrixOverview from '@/employees/components/Subscribable/SubscriptionsMatrixOverview'
import { mapState } from 'vuex'
import toast from '@/services/toast'
import { CATEGORY_ADVANCED_RULES } from '@/constants'

export default {
  name: 'GroupSubscriptionsMatrixOverview',

  components: { GroupSubscriptionsFilter, Loader, SubscriptionsMatrixOverview },

  props: {
    apiRoute: {
      required: true,
      type: String,
    },
    subscribableGroupingId: {
      required: false,
      type: String,
      default: null,
    },
  },

  data () {
    return {
      filters: { groups: [] },
      isLoading: true,
      studentSubscribables: null,
      showFilter: true,
    }
  },

  computed: {
    ...mapState({
      groups (state) {
        return state.groups.groups
      },

      subscribableGrouping (state) {
        return this.subscribableGroupingId ? state.subscribableGroupings.subscribableGroupings[this.subscribableGroupingId] : null
      },

      subscribables (state) {
        let subscribables = state.subscribables.subscribables

        subscribables = Object.values(subscribables).filter(subscribable => {
          if (this.filters.groups.length > 0) {
            let ids = this.filters.groups.map(group => parseInt(group.id))
            if (!ids.includes(parseInt(subscribable.targetGroup))) {
              return false
            }
          }

          return true
        })

        return subscribables
      },

      terms (state) {
        return state.terms.terms
      },
    }),

    isAdvancedRubric () {
      if (this.subscribableGrouping) {
        return this.subscribableGrouping.logicCategory === CATEGORY_ADVANCED_RULES
      }

      return false
    },
  },

  created () {
    this.$store.dispatch('getSubscribables', { apiRoute: this.apiRoute }).then((response) => {
      this.studentSubscribables = _.groupBy(response.student_subscribables, function (studentSubscribable) {
        return studentSubscribable.student
      })
      this.isLoading = false
    }).catch((error) => {
      // Need to add defaultErrorMessage here later
      toast.error(error.response)
    })
  },

  methods: {
    nameOfGroup (subscribable) {
      return this.selectedGroup(subscribable) == null ? null : this.selectedGroup(subscribable).name
    },

    selectedGroup (subscribable) {
      return subscribable.targetGroup == null ? null : Object.values(this.groups).find(group => parseInt(group.id) === parseInt(subscribable.targetGroup))
    },

    termOfSelectedGroup (subscribable) {
      let group = this.selectedGroup(subscribable)

      let term = Object.values(this.terms).find(term => parseInt(group.term) === parseInt(term.id))

      return term == null ? null : term.name
    },
    processShowFilter(event){
      this.showFilter = event.showFilter
    },
  },
}
</script>

<style lang="scss">
    .filter-component {
        padding: 0px;

        .control-label {
            padding: 0px;
        }
    }
    .filter-component-date {
        .control-label {
            padding-top: 10px;
        }
    }
</style>
